import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toggleLabel: {
		id: 'personal-settings-preference-fields.common.email-enabled.toggle-label',
		defaultMessage: 'Allow emails for issue activity',
		description: 'Label for toggling email notifications on/off',
	},
	emailEnabledToggleLabel: {
		id: 'personal-settings-preference-fields.common.email-enabled.email-enabled-toggle-label',
		defaultMessage: 'Send me emails for issue activity',
		description: 'Label for toggling email notifications on/off',
	},
	toggleLabelIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.email-enabled.toggle-label-issue-term-refresh',
		defaultMessage: 'Allow emails for work item activity',
		description: 'Label for toggling email notifications on/off',
	},
	emailEnabledToggleLabelIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.email-enabled.email-enabled-toggle-label-issue-term-refresh',
		defaultMessage: 'Send me emails for work item activity',
		description: 'Label for toggling email notifications on/off',
	},
});
